package ui.app.rss


import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.draw.*
import androidx.compose.ui.unit.*
import tk.mallumo.compose.navigation.*
import tools.*

data class AppRssListingArgs(var companyId: Long = -1)

@ComposableNavNode(AppRssListingArgs::class)
@Composable
fun AppRssListingUI() {

    with(AppRssListingScope.remember()) {
        Content()
    }

}

@Composable
fun AppRssListingScope.Content() {
    Column(Modifier.fillMaxSize()) {
        Box(
            Modifier.fillMaxWidth()
                .weight(1F)
        ) {
            NavigationChildRssListingContent(Node.EmptyUI)
        }
        NavigationBar(
            Modifier.fillMaxWidth()
                .padding(horizontal = 8.dp)
                .padding(bottom = 8.dp)
                .clip(CardDefaults.shape)
        ) {
            tabs.forEach { tabDefinition ->
                NavigationBarItem(
                    selected = tabDefinition.tag == vm.selectedTab.value.tag,
                    onClick = {
                        with(tabDefinition) { onClick(tabDefinition) }
                    },
                    label = { Text(tabDefinition.label.rememberString()) },
                    icon = { Icon(tabDefinition.icon, null) })
            }
        }

    }
    LaunchedEffect(vm.selectedTab.value) {
        with(vm.selectedTab.value) {
            nav.findChildNavigation(Graph.RssListingContent)
                ?.navigateTo(tag, args, true)
        }
    }
}
